import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/audiences/new/loading';

export const Route = createFileRoute('/_private/settings/audiences/new')({
  component: Loading,
});
